<template>
    <div class="socialMedia">
        <h2>Verknüpfte Profile</h2>
        <div v-if="readonly">
            <div v-if="visible('instagram')">
                <div v-if="instagramAccount">
                    <div class="label-item verticalAlignTop black500"><span>Instagram</span></div>
                    <div class="content-item verticalAlignTop lightGrey">{{instagramAccount.url}}</div>
                    <profileItemVisibilityEditor v-if="instagramAccount" :item="profileitems.instagram.url" :readOnly="readonly"></profileItemVisibilityEditor>
                </div>
            </div>
            <div v-if="visible('twitter')">
                <div v-if="twitterAccount">
                    <div class="label-item verticalAlignTop black500"><span>Twitter</span></div>
                    <div class="content-item verticalAlignTop lightGrey">{{twitterAccount.url}}</div>
                    <profileItemVisibilityEditor v-if="twitterAccount" :item="profileitems.twitter.url" :readOnly="readonly"></profileItemVisibilityEditor>
                </div>
            </div>
        </div>
        <div v-else>
		    <p v-if="errorMessage" class="errorText">
	            {{ errorMessage }}
	        </p>
	        <p v-if="removeSuccessful" class="errorText" style="margin-top:15px;">
	            Verknüpfung erfolgreich entfernt
	        </p>
	        <p v-if="connectSuccessful" class="errorText" style="margin-top:15px;">
	            Verknüpfung erfolgreich hergestellt
	        </p>
	        <div v-if="visible('instagram')">
                <div class="label-item verticalAlignTop black500"><span>Instagram</span></div>
                <div class="content-item verticalAlignTop lightGrey">
                    <div v-if="instagramAccount">
                        <div>{{instagramAccount.url}}</div>
                        <a v-on:click="remove('INSTAGRAM')">Verknüpfung löschen</a>
                    </div>
                    <div v-else>
                        <a v-on:click="connect('INSTAGRAM')" target="_blank">Jetzt verknüpfen</a>
                    </div>
                </div>
	            <profileItemVisibilityEditor v-if="instagramAccount" :item="profileitems.instagram.url" :readOnly="readonly"></profileItemVisibilityEditor>
                <div style="clear: both;"></div>
            </div>
	        <div v-if="visible('twitter')">
		        <div class="label-item verticalAlignTop black500"><span>Twitter</span></div>
		        <div class="content-item verticalAlignTop lightGrey">
			        <div v-if="twitterAccount">
			            <div>{{twitterAccount.url}}</div>
			            <a v-on:click="remove('TWITTER')">Verknüpfung löschen</a>
			        </div>
			        <div v-else>
			            <a v-on:click="connect('TWITTER')" target="_blank">Jetzt verknüpfen</a>
			        </div>
			    </div>
	            <profileItemVisibilityEditor v-if="twitterAccount" :item="profileitems.twitter.url" :readOnly="readonly"></profileItemVisibilityEditor>
			    <div style="clear: both;"></div>
			</div>
		</div>
        <h2>Manuell eingetragene Profile</h2>
	</div>
</template>
<script>
    import ProfileItemVisibilityEditor from './ProfileItemVisibilityEditor.vue';
	export default {
		name: 'profileSocialMediaConnector',
		props: {
            item: Object,
            socialnetworks: Array,
            readonly: Boolean,
            profileitems: Object
        },
        data: function() {
            return {
                removeSuccessful: false,
                connectSuccessful: false,
                errorMessage: null
        	}
        },
        watch: {
        	socialnetworks: {
        		handler: function(newValue, oldValue) {
        		    if(newValue != null) {
                        this.$emit('updateSocialNetworkUrlItem', newValue);
        		    }
                }
        	}
        },
        computed: {
            twitterAccount: function () {
            	var result = null;
            	if(this.socialnetworks) {
                    this.socialnetworks.forEach(function(element) {
                        if(element.type === 'TWITTER') {
                            result = element;
                            return;
                        }
                    });
                }
                return result;
            },
            instagramAccount: function () {
            	var result = null;
                if(this.socialnetworks) {
                    this.socialnetworks.forEach(function(element) {
                        if(element.type === 'INSTAGRAM') {
                        	result = element;
                        	return;
                        }
                    });
                }
                return result;
            }
        },
        methods: {
            removeSuccess: function(data) {
                if(data == "success") {
                	this.removeSuccessful = true;
                	this.$emit('updateSocialNetworks');
                }else {
                	this.errorMessage = data;
                }
            },
            remove: function(type) {
            	this.removeSuccessful = false;
            	this.connectSuccessful = false;
            	this.errorMessage = null;
            	this.removeError = null;
            	jQuery.ajax ({
                    url: '/profile/removeSocialMediaAccount/' + type,
                    type: 'GET',
                    contentType: "text/plain; charset=utf-8",
                    success: this.removeSuccess,
                    error: function() {console.log("could not remove social network")}
                });
            },
            connect: function(type) {
            	this.removeSuccessful = false;
                this.connectSuccessful = false;
                this.errorMessage = null;
            	var socialMediaWindow = window.open('/profile/connectSocialMediaAccount/'+type, 'connectSocialNetwork', 'width=800,height=600');
            	window.vueInst = this;
            	return !socialMediaWindow;
            },
            onCloseSocialMediaWindow(success, errorMessage) {
            	if(success) {
            		this.connectSuccessful = true;
            		this.$emit('updateSocialNetworks');
            	}else {
            		this.errorMessage = errorMessage;
            	}
            },
            onChooseFacebookPage(pageId) {
            	this.removeSuccessful = false;
                this.connectSuccessful = false;
                this.errorMessage = null;
                var socialMediaWindow = window.open('/profile/connectSocialMediaAccountWithPage/'+pageId, 'connectSocialNetwork', 'width=800,height=600');
                window.vueInst = this;
                return !socialMediaWindow;
            },
            visible: function(network) {
            	var result = false;
            	this.item.propertyValue.choices.forEach(function(entry) {
	            	if(entry.toLowerCase() === network) {
	            		result = true;
	            		return;
	            	}
            	});
            	return result;
            }
        },
        components: { 
            ProfileItemVisibilityEditor
        }
	}
</script>


// WEBPACK FOOTER //
// ProfileSocialMediaConnector.vue?22efdfe4